/* IMPORT HERE */

import { ThemeUICSSObject } from 'theme-ui';
import { focusOutline } from '../../../../util';

const autocomplete: ThemeUICSSObject = {
  '&:focus-within': focusOutline,

  '.autocomplete__inputWrapper': {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid',
    borderColor: 'palette.border.field',
  },
  '.autocomplete__input': {
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    border: 'none',
    outline: 'none !important',
  },

  '.autocomplete__icons': {
    alignItems: 'center',
    display: 'flex',
    gap: 2,
    height: '24px',
    p: 3,
    position: 'relative',
    width: '30px',
    '.autocomplete__loadingSpinner': {
      position: 'absolute',
      right: '7px',
      width: '20px',
      height: '20px',
    },

    '.autocomplete__downArrow': {
      cursor: 'pointer',
      height: '12px',
      pointerEvents: 'none',
      width: '12px',
    },
  },

  optionsContainer: {
    background: 'palette.background.paper',
    border: '1px solid',
    borderColor: 'palette.border.field',
    overflow: 'auto',
    zIndex: 'tooltip',

    '.autocomplete__option': {
      variant: 'buttons.link',
      border: 'none',
      textDecoration: 'none',
      transition: 'unset',

      '&.focused, &:hover': (theme) =>
        theme.palette.getOneState(
          {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
          },
          'selected',
        ),
    },
  },
};

export default autocomplete;
